import React, { Suspense, lazy, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Shop from './pages/Shop';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import About from './pages/About';
import Contact from './pages/Contact';
import HappyClients from './pages/HappyClients';
import DiwaliSlots from './pages/DiwaliSlots';
const ShareReview = lazy(() => import('./pages/ShareReview'));
const Admin = lazy(() => import('./pages/Admin'));
import ScrollToTop from './components/ScrollToTop';
import SplashScreen from './components/SplashScreen';
import WhatsAppButton from './components/WhatsAppButton';

function SiteLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(() => !sessionStorage.getItem('hitera_splash_seen'));

  const finishSplash = () => {
    sessionStorage.setItem('hitera_splash_seen', '1');
    setShowSplash(false);
  };

  return (
    <div className="App">
      {showSplash && <SplashScreen onFinish={finishSplash} />}
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen bg-burgundy-950" />}>
          <Routes>
            <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
            <Route path="/shop" element={<SiteLayout><Shop /></SiteLayout>} />
            <Route path="/shop/:category" element={<SiteLayout><Shop /></SiteLayout>} />
            <Route path="/product/:id" element={<SiteLayout><ProductDetail /></SiteLayout>} />
            <Route path="/cart" element={<SiteLayout><Cart /></SiteLayout>} />
            <Route path="/checkout" element={<SiteLayout><Checkout /></SiteLayout>} />
            <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
            <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
            <Route path="/happy-clients" element={<SiteLayout><HappyClients /></SiteLayout>} />
            <Route path="/diwali" element={<SiteLayout><DiwaliSlots /></SiteLayout>} />
            {/* Hidden admin route */}
            <Route path="/review" element={<ShareReview />} />
            <Route path="/hitera-admin" element={<Admin />} />
          </Routes>
          </Suspense>
          <Toaster position="top-center" />
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
